// Amber "Ajourné" / "Non délibéré" badge (with the academic reasons on hover)
// for a request whose academic validation needs a second look.
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { AcademicAttention, AttestationType } from '../../../../types/student-requests.types';
import { NO_JURY_DECISION_LABEL } from './requestLabels';

interface AcademicAttentionBadgeProps {
  attention: AcademicAttention | null | undefined;
  requestType: AttestationType;
}

/** Decision text to show for a réussite request needing attention. */
export const attentionDecisionLabel = (attention: AcademicAttention): string =>
  attention.juryDecision ?? NO_JURY_DECISION_LABEL;

export const AcademicAttentionBadge: React.FC<AcademicAttentionBadgeProps> = ({ attention, requestType }) => {
  if (!attention) return null;

  const isReussite = requestType === AttestationType.ATTESTATION_REUSSITE;
  const label = isReussite ? attentionDecisionLabel(attention) : 'À vérifier';
  const title = attention.reasons.length > 0 ? attention.reasons.join('\n') : label;

  return (
    <span
      title={title}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-200"
    >
      <AlertTriangle className="w-3 h-3" />
      {label}
    </span>
  );
};

export default AcademicAttentionBadge;
